export default "__VITE_ASSET__DaokYGWp__"